import React from "react";
import { Link } from "react-router-dom";

const CompanyAchievements = () => {
  return (
    <section className="z-index-common mb-5">
      <div className="container th-container2">
        <div className="counter-area-4">
          <div className="row align-items-center justify-content-between">
            {/* Left Section */}
            <div className="col-xl-5">
              <div className="title-area mb-xl-0 text-start text-xl-start mb-50">
                <span className="sub-title6">
                  OUR ACHIVEMENTS
                  <span className="shape right">
                    <span className="dots"></span>
                  </span>
                </span>
                <h2 className="sec-title fw-semibold">
                  Safe, effective pest control with Al Jurf.
                </h2>
                <Link to="/contact" className="th-btn mt-10">
                  Contact us
                  <i className="fa-regular fa-arrow-right ms-2"></i>
                </Link>
              </div>
            </div>

            {/* Right Section */}
            <div className="col-xl-7">
              <div className="counter-wrap4">
                <div className="row">
                  {/* Counter 1 */}
                  <div className="col-sm-6 counter-grid-wrap">
                    <div className="counter-grid style4">
                      <div className="counter-grid_icon">
                        <img
                          src="/assets/img/icon/counter-icon4-1.svg"
                          alt="img"
                        />
                      </div>
                      <div className="details">
                        <h2 className="counter-grid_number">
                          <span className="counter-number">2</span>k
                          <span className="text-theme fw-normal">+</span>
                        </h2>
                        <p className="counter-grid_text">Projects Complete</p>
                      </div>
                    </div>
                  </div>

                  {/* Counter 2 */}
                  <div className="col-sm-6 counter-grid-wrap">
                    <div className="counter-grid style4">
                      <div className="counter-grid_icon">
                        <img
                          src="/assets/img/icon/counter-icon4-2.svg"
                          alt="img"
                        />
                      </div>
                      <div className="details">
                        <h2 className="counter-grid_number">
                          <span className="counter-number">36</span>
                          <span className="text-theme fw-normal">+</span>
                        </h2>
                        <p className="counter-grid_text">Our Team Members</p>
                      </div>
                    </div>
                  </div>

                  {/* Counter 3 */}
                  <div className="col-sm-6 counter-grid-wrap">
                    <div className="counter-grid style4">
                      <div className="counter-grid_icon">
                        <img
                          src="/assets/img/icon/counter-icon4-3.svg"
                          alt="img"
                        />
                      </div>
                      <div className="details">
                        <h2 className="counter-grid_number">
                          <span className="counter-number">1.5</span>k
                          <span className="text-theme fw-normal">+</span>
                        </h2>
                        <p className="counter-grid_text">Clients Are Happy</p>
                      </div>
                    </div>
                  </div>

                  {/* Counter 4 */}
                  <div className="col-sm-6 counter-grid-wrap">
                    <div className="counter-grid style4">
                      <div className="counter-grid_icon">
                        <img
                          src="/assets/img/icon/counter-icon4-4.svg"
                          alt="img"
                        />
                      </div>
                      <div className="details">
                        <h2 className="counter-grid_number">
                          <span className="counter-number">16</span>
                          <span className="text-theme fw-normal">+</span>
                        </h2>
                        <p className="counter-grid_text">Years Experience</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompanyAchievements;
